/** Bridges between React providers (Clerk, TenantContext) and the non-React
 *  apiFetch helper. Both values are read synchronously by apiFetch; the
 *  providers register them via the functions below. */

type TokenGetter = () => Promise<string | null>;

let tokenGetter: TokenGetter | null = null;
let activeTenantSlug: string | null = null;

export function registerTokenGetter(fn: TokenGetter): void {
  tokenGetter = fn;
}

export async function getToken(): Promise<string | null> {
  if (!tokenGetter) return null;
  return tokenGetter();
}

export function registerActiveTenantSlug(slug: string | null): void {
  activeTenantSlug = slug;
}

export function getActiveTenantSlug(): string | null {
  return activeTenantSlug;
}
